import * as DismissedSuggestionsSlice from '@frontend/redux/slices/dismissedSuggestionsSlice';
import { useDispatch } from 'react-redux';
import type { BaseRootState } from './helpers';
import { useSelector } from './useSelector';

export const useDismissedSuggestionsSlice = <TRootState extends Pick<BaseRootState, 'dismissedSuggestions'>>() => {
  const dispatch = useDispatch();

  const { dismissedSuggestions } = useSelector<TRootState>()(({ dismissedSuggestions }) => dismissedSuggestions);

  const dismissSuggestion = (suggestion: string) => dispatch(DismissedSuggestionsSlice.dismissSuggestion(suggestion));

  const undismissSuggestion = (suggestion: string) =>
    dispatch(DismissedSuggestionsSlice.undismissSuggestion(suggestion));

  const clearDismissedSuggestions = () => dispatch(DismissedSuggestionsSlice.clearDismissedSuggestions());

  return {
    clearDismissedSuggestions,
    dismissSuggestion,
    dismissedSuggestions,
    undismissSuggestion,
  };
};
